import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    sendPrompt: -1,
    checkHealthSummary: -1,
    doctorEvaluate: -1,
    detailsEvaluate: -1,
  },
  data: {},
  checkHealthSummary: null,
  meta: {},
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ACTION_TYPES.AI_SEND_PROMPT_REQUESTED:
      return {
        ...state,
        status: {
          sendPrompt: 0,
        },
      };
    case ACTION_TYPES.AI_SEND_PROMPT_SUCCEED:
      return {
        ...state,
        status: {
          sendPrompt: 1,
        },
        data: payload.data,
      };
    case ACTION_TYPES.AI_SEND_PROMPT_FAILED:
      return {
        ...state,
        status: {
          sendPrompt: 2,
        },
        error,
      };

    case ACTION_TYPES.AI_CHECK_HEALTH_SUMMARY_REQUESTED:
      return {
        ...state,
        status: {
          checkHealthSummary: 0,
        },
        checkHealthSummary: null,
      };
    case ACTION_TYPES.AI_CHECK_HEALTH_SUMMARY_SUCCEED:
      return {
        ...state,
        status: {
          checkHealthSummary: 1,
        },
        checkHealthSummary: payload.data,
      };
    case ACTION_TYPES.AI_CHECK_HEALTH_SUMMARY_FAILED:
      return {
        ...state,
        status: {
          checkHealthSummary: 2,
        },
        checkHealthSummary: null,
        error,
      };

    case ACTION_TYPES.AI_DOCTOR_EVALUATE_REQUESTED:
      return {
        ...state,
        status: {
          doctorEvaluate: 0,
        },
      };
    case ACTION_TYPES.AI_DOCTOR_EVALUATE_SUCCEED:
      return {
        ...state,
        status: {
          doctorEvaluate: 1,
        },
        checkHealthSummary: payload.data,
      };
    case ACTION_TYPES.AI_DOCTOR_EVALUATE_FAILED:
      return {
        ...state,
        status: {
          doctorEvaluate: 2,
        },
        error,
      };

    case ACTION_TYPES.AI_GET_EVALUATE_REQUESTED:
      return {
        ...state,
        status: {
          detailsEvaluate: 0,
        },
      };
    case ACTION_TYPES.AI_GET_EVALUATE_SUCCEED:
      return {
        ...state,
        status: {
          detailsEvaluate: 1,
        },
        checkHealthSummary: payload.data,
      };
    case ACTION_TYPES.AI_GET_EVALUATE_FAILED:
      return {
        ...state,
        status: {
          detailsEvaluate: 2,
        },
        error,
      };
    default:
      return state;
  }
}
